// extracted by mini-css-extract-plugin
export default {"invalid":"VerificacionEdit_invalid__gn4th"};